<template>
  <div class="radioBullet">
    <div class="uiRadio" :class="{'checked': trueVal,'disabled':disabled}"></div>
  </div>
</template>

<script>
export default {
  name: "Radio",
  props: ["trueVal", "disabled"],
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
@import "../../assets/css/style.less";

.radioBullet {
  position: relative;
  margin-right: -20px;
  margin-top: 4px;
  display: inline-block;
  float: right;
}

.uiRadio {
  border-radius: 50%;
  border: 1px solid @grey-dark;
  min-width: 15px;
  height: 15px;
  position: absolute;
  align-self: center;
  right: 0px;
  background: @white;
  box-shadow: inset 0 0 0px 2px @white;
  transition: all 0.2s ease-in;
  &:hover {
    cursor: pointer;
  }
}

.checked {
  border-color: @grey-dark;
  background: @grey-dark;
}
.disabled {
  opacity: 0.4;
  &:hover {
    cursor: not-allowed;
  }
  .uiRadio {
    border-color: @grey;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ui/radio.vue